import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

import { RtComponentSize } from '../../props/component-size';
import { RtButtonVariant, RtPlanButtonVariant } from './button.types';

@Directive({
  selector: 'rt-button-base',
  host: {
    '[class]': 'size + " " + variant',
    '[class.disabled]': 'disabled === true',
    '(click)': 'onClick($event)',
  },
})
export class BaseButtonDirective {
  @Input() public size: Extract<RtComponentSize, 'small' | 'medium'> = 'medium';
  @Input() public variant: RtButtonVariant | RtPlanButtonVariant;
  @Input() public disabled: boolean = false;

  constructor(public renderer: Renderer2, public elRef: ElementRef) {}

  public onClick(event: Event) {
    if (!this.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  public addClass(name: string) {
    this.renderer.addClass(this.elRef.nativeElement, name);
  }

  public removeClass(name: string) {
    this.renderer.removeClass(this.elRef.nativeElement, name);
  }
}
